export default __webpack_public_path__ + "static/media/logo.65ca1d9e.svg";